import * as React from "react";
import i18next from "i18next";
import { ILayerState } from "../config";
import { Checkbox } from "../../Elements/Checkbox";
import { GroupVisibility } from "../enums";

export interface IGroupVisibilityButtonProps {
    layer: ILayerState;
    onClick: (id: string, state: GroupVisibility) => void;
}

interface IGroupVisibilityCount {
    visible: number;
    hidden: number;
    total: number;
}

export const GroupVisibilityButton = ({ layer, onClick }: IGroupVisibilityButtonProps): JSX.Element => {
    const getNextGroupVisibilityState = (current: GroupVisibility) => {
        switch (current) {
            case GroupVisibility.VISIBLE:
                return GroupVisibility.HIDDEN;
            case GroupVisibility.HIDDEN:
                return GroupVisibility.VISIBLE;
            case GroupVisibility.MIXED:
                return GroupVisibility.VISIBLE;
        }
    };
    const countSublayersByVisibility = (layer: ILayerState): IGroupVisibilityCount => {
        const group = {
            total: 0,
            visible: 0,
            hidden: 0
        };

        if (!layer.sublayers || !layer.sublayers.length) {
            return group;
        }

        group.total = layer.sublayers.length;

        for (const subLayer of layer.sublayers) {
            if (subLayer.visible) {
                group.visible++;
            } else {
                group.hidden++;
            }

            const subLayerVisibility = countSublayersByVisibility(subLayer);
            group.total += subLayerVisibility.total;
            group.visible += subLayerVisibility.visible;
            group.hidden += subLayerVisibility.hidden;
        }

        return group;
    };

    const onClickHandler = (e?: React.MouseEvent) => {
        onClick(layer.id, getNextGroupVisibilityState(state));
        e && e.stopPropagation();
    };

    const groupVisibility = countSublayersByVisibility(layer);
    let state =
        groupVisibility.visible > 0 && groupVisibility.hidden > 0 ? GroupVisibility.MIXED : GroupVisibility.HIDDEN;
    if (groupVisibility.total === groupVisibility.visible && layer.visible) {
        state = GroupVisibility.VISIBLE;
    }

    return (
        <span className="layerGroupVisibility">
            <Checkbox
                label={i18next.t("showAll")}
                checked={state === GroupVisibility.VISIBLE}
                onChange={() => onClickHandler()}
            />
        </span>
    );
};
